import { render, staticRenderFns } from "./PopWindows.vue?vue&type=template&id=0bd51e98&"
import script from "./PopWindows.vue?vue&type=script&lang=js&"
export * from "./PopWindows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports